import { EInfrastructureActionType, ISetFeaturesStatusPayload } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const setFeaturesStatus = actionGenerator<
  EInfrastructureActionType.SetFeaturesStatus,
  ISetFeaturesStatusPayload
>(EInfrastructureActionType.SetFeaturesStatus);
